import React from "react";
import ReactDOM from "react-dom/client";
import { Capacitor } from "@capacitor/core";
import "@/index.css";
import App from "@/App";

// Mobile app only: media URL rewriting + status-bar safe area. The module
// is never even loaded in the browser, so the website is untouched.
if (Capacitor.isNativePlatform()) {
  import("@/lib/native").then((m) => m.initNativeShell());
}

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
);
